export const setlocations_tmp = data => ({ type: 'setlocations', data: data })
export const setflows_tmp = data => ({ type: 'setflows', data: data })
export const setconfig_tmp = data => ({ type: 'setconfig', data: data })
export const setcustomlayers_tmp = data => ({ type: 'setcustomlayers', data: data })